import get from 'lodash/get.js';
import has from 'lodash/has.js';
import isFunction from 'lodash/isFunction.js';

export default class Cache {
    static store = {};

    static has(key) {
        return has(Cache.store, key);
    }

    static get(key, defaultValue) {
        return get(Cache.store, key, defaultValue);
    }

    static set(key, value) {
        Cache.store[key] = value;
    }

    static clear() {
        Cache.store = {};
    }

    static forgetPrefix(prefix) {
        for (const key of Object.keys(Cache.store)) {
            if (key.startsWith(prefix)) {
                delete Cache.store[key];
            }
        }
    }

    static remember(key, value) {
        if (Cache.has(key)) {
            return Cache.get(key);
        }

        const resolvedValue = isFunction(value) ? value() : value;

        Cache.set(key, resolvedValue);

        return resolvedValue;
    }
}
